import warningIcon from "@assets/images/warning-red.svg";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import MyTypography from "@saleor/components/MyTypography";
import classNames from "classnames";
import React from "react";
import { FormattedMessage } from "react-intl";

import useStyles from "./styles";

interface CashSaleStatusProps {
  status: "S" | "F" | "N" | string | null;
}

const CashSaleStatus: React.FC<CashSaleStatusProps> = ({
  status: originalStatus
}) => {
  const status = originalStatus?.toUpperCase();
  const classes = useStyles();

  if (!status || status === "N") {
    return null;
  }

  if (status === "S") {
    return (
      <div
        className={classNames(
          classes.cashSaleStatus,
          classes.cashSaleStatusSuccess
        )}
      >
        <FiberManualRecordIcon fontSize="small" />
        <MyTypography variant="body3">
          <FormattedMessage defaultMessage="เชื่อมต่อกับระบบ" />{" "}
          <b>
            <FormattedMessage defaultMessage="Cash Sale" />
          </b>{" "}
          <FormattedMessage defaultMessage="สำเร็จ" />
        </MyTypography>
      </div>
    );
  }

  if (status === "F") {
    return (
      <div
        className={classNames(
          classes.cashSaleStatus,
          classes.cashSaleStatusFailed
        )}
      >
        <img
          src={warningIcon}
          alt="Warning Icon"
          style={{ width: 16, height: 16 }}
        />
        <MyTypography variant="body3">
          <FormattedMessage defaultMessage="ไม่สามารถเชื่อมต่อกับระบบ Cash Sale ได้ กรุณาไปที่หน้า" />{" "}
          <b>
            <FormattedMessage defaultMessage="Change Order" />
          </b>{" "}
          <FormattedMessage defaultMessage="เพื่อส่งข้อมูลให้ระบบอีกครั้ง" />
        </MyTypography>
      </div>
    );
  }

  return null;
};

export default CashSaleStatus;
